// Ported from Dealtracker src/appframe/tours/helpIds.ts (commit 9b8342a), with Niobe's own ids.

/**
 * Every `data-help-id` a tour may point at. A tour step's `target` is typed as `HelpId`, so
 * referencing an anchor that is not listed here fails `tsc`. Add the id here when you add the
 * attribute to a component; remove both together.
 *
 * `data-help-id` is a contract dedicated to help, independent of `data-testid`.
 */
export const HELP_IDS = [
  // Top bar (TopBar.tsx): the `?` Help menu button
  'topbar-help',
  // Home page (HomePage.tsx): the "New bid" button of the header
  'home-new-bid',
  // Workspace (LeftNav.tsx): the bid navigation — artefacts, their parts, the knowledge entry
  'nav-tree',
  // Editor (Canvas.tsx): the focus-mode expand/contract button
  'canvas-focus',
] as const

export type HelpId = (typeof HELP_IDS)[number]

/** CSS selector of the element carrying `data-help-id="<id>"`. */
export function helpIdSelector(id: HelpId): string {
  return `[data-help-id="${id}"]`
}
